
import { of as observableOf } from 'rxjs';
import { withLatestFrom, switchMap, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { Http } from '@angular/http';

import {
  REQUEST_WORKSPACES,
  RECEIVE_WORKSPACES,
  receiveWorkspaces,
  requestWorkspaces,
} from './workspaces.actions';

import { IAppState } from '../app.state';

import { normalize, schema } from 'normalizr';

import { Config } from '../universal-config';

const workspace = new schema.Entity('workspaces', {}, {idAttribute: 'globalId'});

@Injectable()
export class WorkspacesEffects {
  url = '/ws';
  shareApiService;

  @Effect() requestWorkspaces$ = this.actions$
    .ofType<any>(REQUEST_WORKSPACES).pipe(
    withLatestFrom(this.store$),
    map(([action, state]) => action.payload),
    switchMap((action) => {
      return this.http.get(`${this.shareApiService}${this.url}`).pipe(
        catchError(() => observableOf(false)));
    }),
    map((response: any) => {
      return receiveWorkspaces(normalize({workspaces: response.json()}, {workspaces: [workspace]}));
    }),
    catchError((err) => observableOf({ type: 'REQUEST_FAILED' })),);

  constructor(
    public actions$: Actions,
    public store$: Store<IAppState>,
    public http: Http,
    public _config: Config
  ) {
    this.shareApiService = _config.get('SHARE_API_SERVICE');
  }
}
